_ = require('lodash')

module.exports = ->
  restrict: 'E'
  scope:
    model: '='
    services: '='
  template: require('./index.pug')()
  link: (scope) ->
    scope.model.tags ||= []
    scope.service_ids = if scope.model.service_ids
      _.reduce(
        scope.model.service_ids,
        ((acc, id) ->
          acc[id] = true
          acc),
        {})
    else
      _.reduce(scope.model.services, ((acc, elem) ->
        acc[elem.id] = true
        acc
      ), {})

    scope.addTagField = ->
      scope.model.tags.push({ text: '', color: 'white' });

    scope.deleteTagField = (tag) ->
      scope.model.tags = _.filter(scope.model.tags, (el) -> !_.eq(el, tag))

    scope.$watch 'service_ids', (->
      scope.model.service_ids =
        _.reduce(scope.service_ids, ((acc, val, key) ->
          acc.push(key) if val
          acc), [])
    ), true

